import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = { class: "select-wrapper" }
const _hoisted_3 = ["id", "name", "disabled"]
const _hoisted_4 = ["value", "disabled"]
const _hoisted_5 = {
  key: 0,
  class: "error-message"
}

import { watch, ref } from 'vue';
import { PropType } from 'vue';
import { useIdGenerator } from '@/shared/designsystem/useIdGenerator';


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'n-select',
},
  __name: 'select',
  props: {
  id: { type: String, default: '' },
  label: { type: String, default: '' },
  name: { type: String, default: '' },
  modelValue: { type: [Object, String, Number, Boolean] as PropType<any>, default: '' },
  options: { type: Array as PropType<any[]>, required: true },
  labelProp: { type: String, default: 'label' },
  valueProp: { type: String, default: 'value' },
  disabledProp: { type: String, default: 'disabled' },
  errorMessage: { type: String, default: '' },
  disabled: { type: Boolean, default: false },
  hideLabel: { type: Boolean, default: false },
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {



const props = __props;

const { inputId } = useIdGenerator(props.id);

const selectedValue = ref<any>(null);

const emit = __emit;

// Sync internal selectedValue with modelValue
watch(
  () => props.modelValue,
  (newValue: any) => {
    selectedValue.value = getOptionValue(newValue);
  },
  { immediate: true },
);

// Extract label from an option
function getOptionLabel(option: any): string {
  if (option === null || option === undefined) return '';
  if (typeof option === 'object' && props.labelProp in option) {
    return option[props.labelProp];
  }
  return String(option); // Fallback for primitives
}

// Extract value from an option
function getOptionValue(option: any): any {
  if (option === null || option === undefined) return null;
  if (typeof option === 'object' && props.valueProp in option) {
    return option[props.valueProp];
  }
  return option; // Use the whole option if primitive or no valueProp
}

// Check if an option is disabled
function isOptionDisabled(option: any): boolean {
  if (typeof option === 'object' && props.disabledProp in option) {
    return !!option[props.disabledProp];
  }
  return false;
}

// Generate a unique key for v-for
function getOptionKey(option: any, index: number): string {
  const value = getOptionValue(option);
  if (value !== null && value !== undefined) {
    return String(value);
  }
  return `${index}`;
}

function handleSelectChange() {
  const selectedOption = props.options.find((opt: any) => {
    const optValue = getOptionValue(opt);
    return optValue === selectedValue.value || JSON.stringify(optValue) === JSON.stringify(selectedValue.value);
  });
  emit('update:modelValue', selectedOption ?? null);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["n-input", { 'has-error': __props.errorMessage }])
  }, [
    _createElementVNode("label", {
      for: _unref(inputId),
      class: _normalizeClass({ 'sr-only': __props.hideLabel })
    }, _toDisplayString(__props.label), 11, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("select", {
        class: "control",
        id: _unref(inputId),
        name: __props.name,
        disabled: __props.disabled,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedValue).value = $event)),
        onChange: handleSelectChange
      }, [
        _renderSlot(_ctx.$slots, "default"),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option, index) => {
          return (_openBlock(), _createElementBlock("option", {
            key: getOptionKey(option, index),
            value: getOptionValue(option),
            disabled: isOptionDisabled(option)
          }, _toDisplayString(getOptionLabel(option)), 9, _hoisted_4))
        }), 128))
      ], 40, _hoisted_3), [
        [_vModelSelect, selectedValue.value]
      ])
    ]),
    (__props.errorMessage)
      ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(__props.errorMessage), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})